"use strict";

exports.__esModule = true;
function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

exports.default = autoInc();


//////////////////
// WEBPACK FOOTER
// ./~/react-onclickoutside/lib/uid.js
// module id = 1104
// module chunks = 0